import React from 'react';
import { useTranslation } from "react-i18next";
import NewButton from '../Buttons/NewButton';
import { icons, STRIPE_TEST_KEY } from '../../helpers/constants';
import AddCardNewTest from './Stripe/AddCardNewTest';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(STRIPE_TEST_KEY);

const EditCardNew = ({ cards, deleteCard, getCards, clientSecret, param }) => {
    const { t } = useTranslation();
    const css = getComputedStyle(document.documentElement);
    

	const appearance = {
		theme: "flat",
        labels: 'floating',
        variables: {
            fontFamily: 'Sohne, system-ui, sans-serif',
            fontWeightNormal: '500',
            spacingUnit: '3px',
            borderRadius: '24px',
            colorBackground: css.getPropertyValue("--light-grey"),
            colorPrimary: css.getPropertyValue("--dark-grey"),
            accessibleColorOnColorPrimary: '#1A1B25',
            colorText: css.getPropertyValue("--grey-blue"),
            colorTextSecondary: css.getPropertyValue("--dark-grey"),
            colorTextPlaceholder: css.getPropertyValue("--dark-grey"),
            tabIconColor: css.getPropertyValue("--grey"),
            logoColor: css.getPropertyValue("--grey-blue"),
            colorDanger: css.getPropertyValue("--red"),
        },
        rules: {
            ".Input:focus": {
            boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.10) inset",
            borderColor: "transparent",
            outline: "none",
            },
            ".Input--focused": {
            boxShadow: "none",
            borderColor: "transparent",
            },
        },
		// variables: {
		// 	colorPrimary: "#6c757d",
		// 	colorText: "#000000",
		// 	colorDanger: "#fa755a",
		// 	fontFamily: "Roboto, sans-serif",
		// 	borderRadius: "24px",
		// 	spacingUnit: "8px",
		// },
		// rules: {
		// 	".Input": {
		// 		padding: "12px",
		// 		backgroundColor: "#f5f6f7",
		// 	},
		// 	".Label": {
		// 		color: "#6c757d",
		// 	},
		// },
	};
    const options = {
        layout: {
            type: 'tabs',
            defaultCollapsed: false,
        }
    };

    const editCard = () => {
        return(
    
                <div className="d-flex flex-column align-items-center">
                    <div className={`d-flex flex-column w-100 dataplan-selection`}>
                        <p className="bold mb-1 align-self-start">{t("subscription.card")}</p>
                        <div className="d-flex flex-column">
                            <div className={`settings-radius w-100`}>
                                {cards?.map((card, index) => {
                                    const brand = card?.brand
                                    const last4 = card?.last4
                                    const month = card?.exp_month
                                    const year = card?.exp_year
                                    const month_fixed = month < 10 ? `0${month}` : month
                                    return(
                                        <div key={index} className={`p-3 w-100 d-flex justify-content-between align-items-center bg-white ${index < cards?.length-1 ? "border-settings" : ""}`}>
                                            <p className="bold">{`**** **** **** ${last4} ${month_fixed}/${year} ${brand.toUpperCase()}`}</p>
                                            <NewButton notext={true} icon={icons.trashcan} className="rounded8 bg-red me-2 p-3" iconClass={"white-white-icon size_15"} onClick={() => deleteCard(card?.id)} />

                                        </div>
                                        
                                    )
                                })}

                            </div>
                        </div>
                    </div>
                </div>

   
        )
    }

    
    if(!clientSecret || !stripePromise) return;

    const addCard = () => {
        return(
            <>
                <div className="d-flex flex-column align-items-center">
                    <div className={`d-flex flex-column w-100 dataplan-selection`}>
                        <p className="bold mt-3 mb-1 align-self-start">{t("subscription.add_card")}</p>
                        <div className="d-flex flex-column">
                            <div className={`settings-radius w-100 bg-white p-3`}>
                                <Elements stripe={stripePromise} options={{ clientSecret, appearance, options }}>
                                    <AddCardNewTest getCards={getCards} param={param} />
                                </Elements>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        )
    }
    
    return(
        <>
            {cards.length > 0
                ? editCard()
                : addCard()
            }
        </>
    )
}

export default EditCardNew;